<template>
  <div>
    <v-select
      v-model="inputedValue"
      item-text="label"
      item-value="value"
      :items="items"
      dense
      outlined
      hide-details
      class="original-selectbox"
      :height="height"
      :disabled="disabled"
      :placeholder="$t('common.input_unselected_2')"
    >
    </v-select>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Number,
      require: true
    },
    masterData: {
      type: [Array, null],
      require: true
    },
    height: { default: '32px' },
    disabled: { default: false }
  },
  data: () => ({
    items: []
  }),
  computed: {
    inputedValue: {
      get() {
        this.setItems()
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  methods: {
    setItems() {
      // 編集の場合に自身のソート番号を選択肢から除かない
      const filteredMasterData = this.masterData.filter(
        (data) => data != this.value
      )
      this.items = []
      for (let i = 0; i < 1000; i++) {
        if (!filteredMasterData.includes(i + 1)) {
          this.items.push(i + 1)
        }
      }
    }
  }
}
</script>
